import gql from 'graphql-tag';

const MUTATION_COMPLETE_PASSWORD = gql`
  mutation completePassword($input: CompletePasswordInput!) {
    completePassword(input: $input) {
      isSuccess
      message
    }
  }
`;

export default MUTATION_COMPLETE_PASSWORD;
